import { Component, OnInit, EventEmitter, Input, Output, OnChanges } from '@angular/core';
import { Router } from '@angular/router';
import { FormGroup, FormControl, FormBuilder, Validators } from '@angular/forms';

import { ExpenseService } from '../../../service/expense/expense.service';
import { SalesGroupOwnerService } from '../../../service/sales-group-owner/sales-group-owner.service';
import { CommonService } from '../../../service/common/common.service';
import { DialogsService } from '../../../../component/dialog/dialogs.service';
import { environment } from '../../../../environments/environment';
import { validation } from '../../../util/validation';
import { config } from '../../../util/config';
import { GridOptions } from 'ag-grid';

@Component({
  selector: 'wa8012',
  templateUrl: 'wa8012.component.html',
  styleUrls: ['wa8012.component.scss']
})
export class Wa8012Component implements OnInit {
  public componentTitle = 'WA8012:諸掛修正';

  public salesgroups: any;
  public salesgroupowners: any;
  public allsalesgroupowners: any;

  public rowData = [];
  public gridOptions: GridOptions;
  private originalRowData: any[];

  public expenseId: number;
  public ownerId: number;
  public ownerTx: string;
  public bookDt: Date;
  public salesgroupId: number;
  public salesgroupCd: string;
  public salesgroupTx: string;
  public pcsNr: FormControl;
  public salesgroupunitTx: string;
  public unitpricedispNr: number;
  public typetaxCd: string;
  public typetaxTx: string;
  public pricedispNr: number;
  public rawPricedispNr: number;
  public notinvoiceFl: number;
  public expensememoTx: FormControl;
  public expensetaxNr: number;
  public UnitpricedispNrForm: FormControl;

  public validation = validation;

  public working = false;
  public containerHeight = 500;
  public production = environment.production;
  public backgroundColor: string;

  private errorInfo = '';
  private isSubmitButtonEnabled = false;


  @Input() isShow = false;
  @Output() closeButtonClick = new EventEmitter<boolean>();
  private isDelayHide = true;

  public bootDtCls = '';
  public salesgroupCls = '';
  public pcsNrCls = '';
  public expensememoTxCls = '';
  //SW-1872
  public unitpricedispNrCls = '';

  constructor(
    private router: Router,
    private expenseService: ExpenseService,
    private salesGroupOwnerService: SalesGroupOwnerService,
    private commonService: CommonService,
    private dialogsService: DialogsService
  ) {
    this.pcsNr = new FormControl('', [
      Validators.pattern(validation.decimal_3), 
      Validators.pattern(validation.exclude0), 
      Validators.max(validation.pcsNr.maxNr), 
      Validators.min(validation.pcsNr.minNr)
    ]);
    //SW-1872
    this.UnitpricedispNrForm = new FormControl('', [
      Validators.pattern(validation.decimal_2),
      Validators.max(99999999.99),
      Validators.min(-99999999.99)
    ]);
    this.expensememoTx = new FormControl('', [
      Validators.pattern(validation.emBlankOnly),
      Validators.pattern(validation.halfBlankOnly),
      Validators.maxLength(validation.expensememoTx.maxLength)
    ]);

    this.containerHeight = window.innerHeight - config.containerheaderMargin;
    if (this.production) {
      this.backgroundColor = 'primary';
    } else {
      this.backgroundColor = 'warn';
    }
    this.salesGroupOwnerService
      .get()
      .then(outputJson => {
        this.working = false;
        // 単価が定義された売上分類のみ取得するため、売上分類ではなく、荷主別売上分類を利用する
        this.allsalesgroupowners = outputJson.salesgroupowners;
      })
      .catch(error => {
        this.working = false;
        this.errorInfo = this.commonService.getErrorMessage(error);
      });
  }

  ngOnInit(): void { }

  onResize(event) {
    this.containerHeight = window.innerHeight - config.containerheaderMargin;
  }

  getSalesgrouowners(): any[] {
    if (this.ownerId !== undefined && this.allsalesgroupowners !== undefined) {
      var salesgroupowners = this.allsalesgroupowners.filter((item, index) => {
        if (item.ownerId == this.ownerId) return true;
      });
    }
    return salesgroupowners;
  }

  getSalesgroupunitTx(): string {
    if (this.salesgroups !== undefined && this.salesgroupId !== undefined) {
      var salesgroup = this.salesgroups.filter((item, index) => {
        if (item.salesgroupId == this.salesgroupId) return true;
      });
      if (salesgroup.length > 0)
        this.salesgroupunitTx = salesgroup[0].salesgroupunitTx;
    }
    return this.salesgroupunitTx;
  }

  getUnitpricedispNr(): number {
    if (this.salesgroupowners !== undefined && this.salesgroupId !== undefined) {
      var salesgroupowner = this.salesgroupowners.filter((item, index) => {
        if (item.salesgroupId == this.salesgroupId) return true;
      });
      if (salesgroupowner.length > 0)
        this.unitpricedispNr = salesgroupowner[0].unitpricedispNr;
    }
    return this.unitpricedispNr;
  }

  getTypetaxTx(): string {
    if (this.salesgroupowners !== undefined && this.salesgroupId !== undefined) {
      var salesgroupowner = this.salesgroupowners.filter((item, index) => {
        if (item.salesgroupId == this.salesgroupId) return true;
      });
      if (salesgroupowner.length > 0)
        this.typetaxTx = salesgroupowner[0].typetaxTx;
    }
    return this.typetaxTx;
  }

  getPricedispNr() {
    if (this.salesgroupowners !== undefined && this.salesgroupId !== undefined) {
      var salesgroupowner = this.salesgroupowners.filter((item, index) => {
        if (item.salesgroupId == this.salesgroupId) return true;
      });
      if (salesgroupowner.length > 0)
        var tmpPricedispNr = this.UnitpricedispNrForm.value * this.pcsNr.value;
        this.rawPricedispNr = tmpPricedispNr;
        this.pricedispNr = Math.round(Math.abs(tmpPricedispNr)) * ((tmpPricedispNr < 0) ? -1 : 1 );
    }
    return this.pricedispNr;
  }

  getExpensetaxNr() {
    if (this.salesgroupowners !== undefined && this.salesgroupId !== undefined) {
      var salesgroupowner = this.salesgroupowners.filter((item, index) => {
        if (item.salesgroupId == this.salesgroupId) return true;
      });
      if (salesgroupowner.length > 0)
        this.expensetaxNr = this.pricedispNr * 0.08;
    }
    return this.expensetaxNr;
  }

  onSubmit() {
    var expensememoTx = this.expensememoTx.value ? this.expensememoTx.value.trim() : '';
    let errors = false;
    if (this.pricedispNr > validation.pricedispNr.maxNr) {
      this.errorInfo = validation.message.priceOver + validation.pricedispNr.maxNr.toString();
      return;
    }
    if (this.pricedispNr < validation.pricedispNr.minNr) {
      this.errorInfo = '金額が下限を超えています。下限額：' + validation.pricedispNr.minNr.toString();
      return;
    }    
    if (this.pcsNr.errors !== null) {
      this.pcsNr.markAsTouched({ onlySelf: true });
      errors = true;
    }
    //SW-1872
    if (this.UnitpricedispNrForm.errors !== null) {
      this.UnitpricedispNrForm.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (this.expensememoTx.errors !== null) {
      this.pcsNr.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (errors) {
      return;
    }
    var salesgroup = this.salesgroups.filter((item, index) => {
      if (item.salesgroupId == this.salesgroupId) return true;
    });
    this.salesgroupTx = salesgroup[0].salesgroupTx;
    var salesgroupowner = this.salesgroupowners.filter((item, index) => {
      if (item.salesgroupId == this.salesgroupId) return true;
    });
    this.typetaxCd = salesgroupowner[0].typetaxCd;
    //
    //SW-2097　ダブルクリック抑止
    if (this.working) return;
    this.working = true;
    this.expenseService
      .put(
        this.expenseId,
        this.bookDt,
        +this.salesgroupId,
        this.UnitpricedispNrForm.value,
        this.pcsNr.value,
        this.rawPricedispNr,
        this.typetaxCd,
        0,
        this.notinvoiceFl,
        0,
        expensememoTx,
        'wa8012'
      )
      .then(outputJson => {
        this.working = false;
        this.closeButtonClick.emit(true);
        sessionStorage.removeItem('wa8012openwindow');
      })
      .catch(error => {
        this.working = false;
        this.errorInfo = this.commonService.getErrorMessage(error);
      });
  }

  ngOnChanges() {
    if (this.isShow) {
      this.isDelayHide = false;
      this.errorInfo = '';
      this.renderAndSetData();
      this.salesgroups = this.getSalesgrouowners();
      this.salesgroupowners = this.getSalesgrouowners();
    } else {
      setTimeout(() => {
        this.isDelayHide = true;
      }, 300);
    }
  }

  closeOtherWindow() {
    this.errorInfo = '';

    this.closeButtonClick.emit(true);
    sessionStorage.removeItem('rowExpense');
  }

  renderAndSetData() {
    const expense: object = JSON.parse(sessionStorage.getItem('rowExpense'));
    this.expenseId = expense['expenseId'];
    this.ownerId = expense['ownerId'];
    this.ownerTx = expense['ownerTx'];
    this.bookDt = expense['bookDt'];
    this.salesgroupId = expense['salesgroupId'];
    this.salesgroupCd = expense['salesgroupCd'];
    this.salesgroupTx = expense['salesgroupTx'];
    var pcsNr = expense['pcsNr'];
    this.salesgroupunitTx = expense['salesgroupunitTx'];
    var unitpricedispNr = expense['unitpricedispNr'];
    this.typetaxCd = expense['typetaxCd'];
    this.typetaxTx = expense['typetaxTx'];
    this.pricedispNr = expense['pricedispNr'];
    this.notinvoiceFl = expense['notinvoiceFl'];
    this.expensetaxNr = expense['expensetaxNr'];
    var expensememoTx = expense['expensememoTx'];

    this.pcsNr.setValue(pcsNr);
    this.expensememoTx.setValue(expensememoTx);
    //SW-1872
    this.unitpricedispNr = expense['unitpricedispNr'];
    this.UnitpricedispNrForm.setValue(unitpricedispNr);
  }

  ngDoCheck() {
    if (this.isShow) {
      const expense: object = JSON.parse(sessionStorage.getItem('rowExpense'));

      this.bootDtCls = this.bookDt === expense['bookDt'] ? '' : 'active';
      this.salesgroupCls = this.salesgroupId == 0 ? 'error' : this.salesgroupId == expense['salesgroupId'] ? '' : 'active';
      this.pcsNrCls = this.pcsNr.value === expense['pcsNr'] ? '' : this.pcsNr.errors == null ? 'active' : 'error';
      this.unitpricedispNrCls = this.UnitpricedispNrForm.value === expense['unitpricedispNr'] ? '' : this.UnitpricedispNrForm.errors == null ? 'active' : 'error';
      this.expensememoTxCls = this.expensememoTx.value === expense['expensememoTx'] ? '' : this.expensememoTx.errors == null ? 'active' : 'error';
      if (
        this.pcsNrCls !== 'error' &&
        this.unitpricedispNrCls !== 'error' &&
        this.salesgroupCls !== 'error' &&
        this.expensememoTxCls !== 'error'
      )
        this.isSubmitButtonEnabled =
          this.notinvoiceFl != expense['notinvoiceFl'] ||
          this.salesgroupCls === 'active' ||
          this.bootDtCls === 'active' ||
          this.pcsNrCls === 'active' ||
          this.unitpricedispNrCls === 'active' ||
          this.expensememoTxCls === 'active';
      else
        this.isSubmitButtonEnabled = false;
    }
  }

  changeSalesgroup(event: number) {
    //SW-1872　項目選択時に単価セット
    this.unitpricedispNr = this.getUnitpricedispNr();
    this.UnitpricedispNrForm.setValue(this.unitpricedispNr);
  }

  clrErr() {
    this.errorInfo = '';
  }
}



// WEBPACK FOOTER //
// /home/runner/work/saas_wms_prod_ui_pc/saas_wms_prod_ui_pc/src/app/pages/wa8Billing/wa8012/wa8012.component.ts